const NAV_ITEMS = [
    {
        anchor: '#carrier-section',
        text: 'tocLinkCarriers',
    },
    {
        anchor: '#routes-header-section',
        text: 'tocLinkRoutes',
    },
    {
        anchor: '#about-section',
        text: 'tocLinkAbout',
    },
    {
        anchor: '#hotels-section',
        text: 'tocLinkHotels',
    },
    {
        anchor: '#nearby-header-section',
        text: 'tocLinkNearby',
    },
    {
        anchor: '#faq-header-section',
        text: 'tocLinkFaqs',
    },
    {
        anchor: '#shuttles-section',
        text: 'tocLinkShuttles',
    },
];

export {
    NAV_ITEMS,
};
